import indexConfig from "@/config";
import Vue from "vue";
import store from "@/store";

describe("index config", () => {
  beforeEach(() => {
    jest.spyOn(indexConfig, "install");
    jest.spyOn(indexConfig, "start");
    jest.spyOn(indexConfig, "get");
    jest.spyOn(indexConfig, "getPasoProperties");
  });

  it("testing function called ", () => {
    indexConfig.install(Vue);
    indexConfig.start(jest.fn());
    indexConfig.get();
    indexConfig.getPasoProperties();
    const installFunction = jest.spyOn(indexConfig, "install");
    const startFunction = jest.spyOn(indexConfig, "start");
    const getFunction = jest.spyOn(indexConfig, "get");
    const getPasoPropertiesFunction = jest.spyOn(
      indexConfig,
      "getPasoProperties"
    );
    expect(installFunction).toHaveBeenCalledTimes(1);
    store.dispatch = jest.fn().mockImplementation(() => {
      throw new Error("Error");
    });
    indexConfig.install(Vue);
    expect(installFunction).toHaveBeenCalledTimes(2);
    expect(startFunction).toHaveBeenCalledTimes(1);
    expect(getFunction).toHaveBeenCalledTimes(2);
    expect(getPasoPropertiesFunction).toHaveBeenCalledTimes(1);
  });
});
